import { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { instanciasAPI } from '../api';

type State = { email: string; active: boolean; exists: boolean; canManage: boolean; reason?: string };
export default function SupportAccessDialog({ instance, onClose }: { instance: { id: string; name: string } | null; onClose: () => void }) {
  const [state, setState] = useState<State | null>(null);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [confirmRemove, setConfirmRemove] = useState(false);
  useEffect(() => {
    let active = true;
    setState(null); setError(''); setMessage(''); setConfirmRemove(false);
    if (!instance) return;
    setLoading(true);
    instanciasAPI.supportAccess(instance.id).then(response => { if (active) setState(response.data); })
      .catch(error => { if (active) setError(error.response?.data?.error || 'Não foi possível consultar o acesso.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [instance]);
  const change = async (remove: boolean) => {
    if (!instance) return;
    setBusy(true); setError(''); setMessage('');
    try {
      const response = remove ? await instanciasAPI.removeSupportAccess(instance.id) : await instanciasAPI.createSupportAccess(instance.id);
      setMessage(response.data.message); setConfirmRemove(false);
      setState((await instanciasAPI.supportAccess(instance.id)).data);
    } catch (error: any) { setError(error.response?.data?.error || 'Não foi possível alterar o acesso. Atualize e confira o estado.'); }
    finally { setBusy(false); }
  };
  return <Dialog open={!!instance} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Acesso JBEADM — {instance?.name}</DialogTitle>
    <DialogContent><Stack spacing={2}>
      <Typography>Crie seu acesso à instância com o mesmo e-mail e a senha atuais do Management. Ao criar novamente, a senha na instância será atualizada.</Typography>
      <Alert severity="info">JBEADM é um Super Administrador de suporte e não ocupa vagas do plano. Seu nome aparece na conta e nas ações; revogar desativa o acesso e preserva o histórico.</Alert>
      {loading && <CircularProgress size={24} />}
      {state && <><Typography><strong>{state.email}</strong> · {state.active ? 'Acesso ativo' : state.exists ? 'Acesso desativado' : 'Acesso não criado'}</Typography>
        {!state.canManage && <Alert severity="warning">{state.reason}</Alert>}
      </>}
      {message && <Alert severity="success">{message}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
      {confirmRemove && <Alert severity="warning">Revogar seu acesso JBEADM desta instância? O usuário será desativado e deixará de acessar a instância. O histórico será preservado.</Alert>}
    </Stack></DialogContent>
    <DialogActions sx={{ flexWrap: 'wrap', gap: 1 }}>
      <Button onClick={onClose} disabled={busy}>Fechar</Button>
      {state?.canManage && <>
        {state.active && <Button color="error" disabled={busy} onClick={() => confirmRemove ? change(true) : setConfirmRemove(true)}>{confirmRemove ? 'Confirmar revogação' : 'Revogar acesso JBEADM'}</Button>}
        <Button variant="contained" disabled={busy} onClick={() => change(false)}>{busy ? 'Aguarde...' : state.active ? 'Atualizar acesso JBEADM' : 'Criar acesso JBEADM'}</Button>
      </>}
    </DialogActions>
  </Dialog>;
}
